/**
 * Severity — content-severity ordered scale (4 values).
 *
 * CANONICAL VALUE SET (Phase 5 amendment 2026-04-29, decision D3):
 *   - cyberfind-v2 ontology: 4 values (critical, high, medium, low).
 *   - IntelHub-v2 `severityEnum` in `packages/shared/src/schema/enums.ts` is the
 *     SOURCE OF TRUTH for the value set (`critical`, `high`, `medium`, `low`).
 *   - The "informational" case is represented as `NULL` on nullable severity
 *     columns (articles.severity, stories.max_severity, etc.). Apps that need
 *     to render an "Informational" label do so at the rendering layer when
 *     the column is `NULL`. The ontology no longer enumerates `informational`
 *     as a value — `NULL = informational` is the canonical convention.
 *   - This replaces the earlier 2026-04-19 "subset model" stance which kept
 *     `informational` in the ontology. See spec §5.3 (revised 2026-04-29).
 *
 * Pipeline-alert severity (info/warning/error/critical in cyberfind-v2
 * `pipeline-alerts.ts`) is a DIFFERENT axis — operational log severity,
 * not content severity. Do not conflate.
 */
import type { OntologyEntry } from '../types.js';

export const severity: OntologyEntry[] = [
  { slug: 'critical', name: 'Critical', description: 'Immediate action required — active exploitation or imminent threat', dimension: 'severity', sortOrder: 0, metadata: { numericValue: 4 } },
  { slug: 'high', name: 'High', description: 'Significant risk requiring prompt remediation', dimension: 'severity', sortOrder: 1, metadata: { numericValue: 3 } },
  { slug: 'medium', name: 'Medium', description: 'Moderate risk that should be addressed in normal cycles', dimension: 'severity', sortOrder: 2, metadata: { numericValue: 2 } },
  { slug: 'low', name: 'Low', description: 'Minor risk with limited impact', dimension: 'severity', sortOrder: 3, metadata: { numericValue: 1 } },
];
